/**
 * Mobile menu. Without this module the menu renders as a wrapping row of
 * links; the "js" class lets the stylesheet collapse it behind the toggle on
 * narrow screens, and this wires the toggle, Escape and link clicks.
 */
export function initNav(): void {
  document.documentElement.classList.add("js");

  const toggle = document.querySelector<HTMLButtonElement>("[data-nav-toggle]");
  const nav = document.querySelector<HTMLElement>("[data-nav]");
  if (!toggle || !nav) return;

  const setOpen = (open: boolean) => {
    toggle.setAttribute("aria-expanded", String(open));
    nav.classList.toggle("is-open", open);
  };

  toggle.addEventListener("click", () => {
    setOpen(toggle.getAttribute("aria-expanded") !== "true");
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && nav.classList.contains("is-open")) {
      setOpen(false);
      toggle.focus();
    }
  });

  // A link in the drawer, including an in-page one, should close the drawer behind it.
  nav.addEventListener("click", (event) => {
    if ((event.target as HTMLElement).closest("a")) setOpen(false);
  });
}
